"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageStreamsFilteringParameters = void 0;
/**
 * Describes filtering parameters that can be used when retrieving message streams.
 */
var MessageStreamsFilteringParameters = /** @class */ (function () {
    function MessageStreamsFilteringParameters(messageStreamType, includeArchivedStreams) {
        this.messageStreamType = messageStreamType;
        this.includeArchivedStreams = includeArchivedStreams;
    }
    return MessageStreamsFilteringParameters;
}());
exports.MessageStreamsFilteringParameters = MessageStreamsFilteringParameters;
//# sourceMappingURL=MessageStreamsFilteringParameters.js.map